/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetRealizedPnlSettlementsOptions,
  GetRealizedPnlSettlementsStatus200,
  GetRealizedPnlSettlementsStatus401,
  GetRealizedPnlSettlementsStatus403,
  GetRealizedPnlSettlementsStatus500,
} from '../types/GetRealizedPnlSettlements'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getRealizedPnlSettlements } from '../clients/getRealizedPnlSettlements'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getRealizedPnlSettlementsQueryKey = ({
  query,
}: Omit<GetRealizedPnlSettlementsOptions, 'headers'> = {}) =>
  [{ url: '/v1/realized_pnl_settlements' }, ...(query ? [query] : [])] as const

type GetRealizedPnlSettlementsQueryKey = ReturnType<typeof getRealizedPnlSettlementsQueryKey>

export function getRealizedPnlSettlementsQueryOptions(
  { query }: GetRealizedPnlSettlementsOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getRealizedPnlSettlementsQueryKey({ query })
  return queryOptions<
    GetRealizedPnlSettlementsStatus200,
    ResponseErrorConfig<
      | GetRealizedPnlSettlementsStatus401
      | GetRealizedPnlSettlementsStatus403
      | GetRealizedPnlSettlementsStatus500
    >,
    GetRealizedPnlSettlementsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getRealizedPnlSettlements({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get realized P&L settlements with filters
 * {@link /v1/realized_pnl_settlements}
 */
export function useGetRealizedPnlSettlements<
  TData = GetRealizedPnlSettlementsStatus200,
  TQueryData = GetRealizedPnlSettlementsStatus200,
  TQueryKey extends QueryKey = GetRealizedPnlSettlementsQueryKey,
>(
  {
    query,
  }: {
    query?:
      | GetRealizedPnlSettlementsOptions['query']
      | (() => GetRealizedPnlSettlementsOptions['query'])
  } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetRealizedPnlSettlementsStatus200,
        ResponseErrorConfig<
          | GetRealizedPnlSettlementsStatus401
          | GetRealizedPnlSettlementsStatus403
          | GetRealizedPnlSettlementsStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getRealizedPnlSettlementsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getRealizedPnlSettlementsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetRealizedPnlSettlementsStatus401
      | GetRealizedPnlSettlementsStatus403
      | GetRealizedPnlSettlementsStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
